/*
 * pipedrive-lead.js — Photobooth360Store
 * Envía en paralelo a Pipedrive los datos del formulario de contacto nativo de Sense,
 * SIN interferir con el envío nativo (Shopify sigue mandando el email y mostrando su
 * página de éxito). Usa navigator.sendBeacon (sobrevive a la recarga del submit) con
 * content-type text/plain para evitar el preflight CORS.
 *
 * Campos del lead: NOMBRE, TELÉFONO (internacional, con "+"), EMAIL. (El mensaje no se
 * recoge.) Además captura, de forma OCULTA (sin fricción), la ATRIBUCIÓN de marketing
 * (utm_source/campaign, gclid, fbclid, referrer y landing) con lógica first-touch:
 * se guarda en la PRIMERA visita de la sesión y se envía aunque el usuario navegue antes
 * de rellenar el formulario.
 *
 * Lee los campos por ID (ContactForm-name/email/phone), que NO cambian con el idioma.
 *
 * Instalación: asset del theme cargado desde sections/contact-form.liquid:
 *   <script src="{{ 'pipedrive-lead.js' | asset_url }}" defer></script>
 * + honeypot dentro del <form>:
 *   <input type="text" name="pb_x1" id="pb-x1" tabindex="-1" ...>
 *   (nombre opaco a propósito: un name con significado —empresa, url, web…— se lo
 *   rellena solo el autorrelleno del navegador y el Worker tira el lead por spam)
 */
(function () {
  'use strict';

  // URL del Worker de Cloudflare (custom domain propio de la marca, anti-footprint).
  var WORKER_URL = 'https://leads.photobooth360store.com';
  var STORE_KEY = 'pb360_attr'; // first-touch attribution en sessionStorage

  function val(id) {
    var el = document.getElementById(id);
    return el && typeof el.value === 'string' ? el.value.trim() : '';
  }

  function qp(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  // Atribución first-touch: se captura en la primera visita y persiste durante la sesión.
  // Si ya hay algo guardado, no se sobrescribe (respeta el primer origen del usuario).
  function captureAttribution() {
    var stored = {};
    try {
      stored = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
    } catch (e) {
      stored = {};
    }
    if (!stored.landing) {
      var ref = '';
      try {
        ref = document.referrer && document.referrer.indexOf(location.host) === -1 ? document.referrer : '';
      } catch (e) {}
      var attr = {
        attrSource: qp('utm_source'),
        attrCampaign: qp('utm_campaign'),
        gclid: qp('gclid'),
        fbclid: qp('fbclid'),
        referrer: ref,
        landing: window.location.href,
      };
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify(attr));
      } catch (e) {}
      return attr;
    }
    return stored;
  }

  function getAttribution() {
    try {
      return JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function getTipo() {
    var r = document.querySelector('input[name="contact[Tipo]"]:checked');
    return r ? r.value : 'Comprar';
  }

  // ── Teléfono con prefijo internacional (si el form lo renderiza; fase 1 solo ES) ──
  // Devuelve {cc, min, max, z, pais} del país seleccionado, o null si no hay selector.
  function ccData() {
    var sel = document.getElementById('ContactForm-phone-cc');
    if (!sel || !sel.selectedOptions || !sel.selectedOptions.length) return null;
    var o = sel.selectedOptions[0];
    return {
      cc: o.value,
      min: parseInt(o.dataset.min, 10) || 7,
      max: parseInt(o.dataset.max, 10) || 15,
      z: o.dataset.z === '1',
      pais: (o.textContent || '').replace(/\s*\(\+\d+\)\s*$/, '').trim(),
      errorTpl: sel.dataset.errorTpl || '',
    };
  }

  // Dígitos nacionales limpios: quita separadores, un 0 inicial si el país lo usa
  // (FR 06… → 6…, VE 0412… → 412…) y el propio prefijo si el usuario lo repitió
  // (+34…, 0034… o 34… delante de un número que ya cuadra sin él).
  function nationalDigits(raw, c) {
    var d = String(raw || '').replace(/\D/g, '');
    if (String(raw || '').indexOf('+') !== -1 && d.indexOf(c.cc) === 0) d = d.slice(c.cc.length);
    else if (d.indexOf('00' + c.cc) === 0) d = d.slice(c.cc.length + 2);
    else if (d.indexOf(c.cc) === 0 && d.length - c.cc.length >= c.min && d.length - c.cc.length <= c.max) d = d.slice(c.cc.length);
    if (c.z && d.charAt(0) === '0') d = d.slice(1);
    return d;
  }

  // Teléfono a enviar al Worker: E.164 COMPACTO (+34623000000). Sin selector (otros
  // idiomas, fase 1) devuelve el valor crudo del input, como hasta ahora.
  function composedPhone() {
    var c = ccData();
    var raw = val('ContactForm-phone');
    if (!c) return raw;
    return raw ? '+' + c.cc + nationalDigits(raw, c) : '';
  }

  // Validación de longitud por país sobre el input nativo (bloquea el submit del form
  // de Shopify vía setCustomValidity y muestra el mensaje en el idioma de la página).
  function setupPhoneValidation() {
    var sel = document.getElementById('ContactForm-phone-cc');
    var input = document.getElementById('ContactForm-phone');
    if (!sel || !input) return;
    function check() {
      var c = ccData();
      if (!c || !input.value.trim()) {
        input.setCustomValidity('');
        return;
      }
      var d = nationalDigits(input.value, c);
      if (d.length < c.min || d.length > c.max) {
        var digitos = c.min === c.max ? String(c.min) : c.min + '–' + c.max;
        var msg = c.errorTpl
          ? c.errorTpl.replace('{pais}', c.pais).replace('{digitos}', digitos)
          : 'Teléfono no válido para ' + c.pais + ' (' + digitos + ' dígitos)';
        input.setCustomValidity(msg);
      } else {
        input.setCustomValidity('');
      }
    }
    input.addEventListener('input', check);
    sel.addEventListener('change', check);
    check();
  }

  // Combobox de país con BUSCADOR (mejora progresiva): oculta el <select> nativo y
  // monta un botón + panel con campo de búsqueda que filtra por nombre o prefijo.
  // El <select> sigue siendo la fuente de verdad (POST nativo + ccData()); si este
  // código no corre, el usuario ve el select normal y todo funciona igual.
  function buildCountryPicker() {
    var sel = document.getElementById('ContactForm-phone-cc');
    if (!sel || sel.dataset.pbEnhanced) return;
    sel.dataset.pbEnhanced = '1';
    var wrap = sel.closest('.pb-phone-cc') || sel.parentElement;
    if (!wrap) return;

    function labelText() {
      var o = sel.selectedOptions && sel.selectedOptions[0];
      return o ? o.textContent.trim() : '';
    }
    function norm(s) {
      s = String(s || '').toLowerCase();
      try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
      return s;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pb-cc-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var ccBase = sel.getAttribute('aria-label') || 'Prefijo';
    btn.innerHTML =
      '<span class="pb-cc-btn__label"></span>' +
      '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708Z" fill="currentColor"/></svg>';
    btn.querySelector('.pb-cc-btn__label').textContent = labelText();
    btn.setAttribute('aria-label', ccBase + ' ' + labelText());

    var panel = document.createElement('div');
    panel.className = 'pb-cc-panel';
    panel.hidden = true;
    var search = document.createElement('input');
    search.type = 'text';
    search.className = 'pb-cc-search';
    search.autocomplete = 'off';
    search.placeholder = sel.dataset.searchPlaceholder || 'Buscar país…';
    // Nombre accesible: Chrome marcaba el campo sin id ni name (auditoría UX 29/10/2026)
    search.name = 'pb-cc-search';
    search.setAttribute('aria-label', search.placeholder);
    var list = document.createElement('ul');
    list.className = 'pb-cc-list';
    list.setAttribute('role', 'listbox');
    panel.appendChild(search);
    panel.appendChild(list);

    function render(filter) {
      list.innerHTML = '';
      var f = norm(filter);
      var fDigits = String(filter || '').replace(/\D/g, '');
      var shown = 0;
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        if (f && norm(o.textContent).indexOf(f) === -1 && !(fDigits && o.value.indexOf(fDigits) === 0)) continue;
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.dataset.idx = i;
        li.className = 'pb-cc-item' + (i === sel.selectedIndex ? ' is-selected' : '');
        li.textContent = o.textContent;
        list.appendChild(li);
        shown++;
      }
      if (!shown) {
        var empty = document.createElement('li');
        empty.className = 'pb-cc-empty';
        empty.textContent = '—';
        list.appendChild(empty);
      }
    }
    function open() {
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      search.value = '';
      render('');
      // Altura adaptada al viewport: solo ítems COMPLETOS (múltiplos de 4rem, 3–6),
      // y si abajo no caben ni 3 pero arriba sí, el panel se abre hacia arriba.
      var ITEM = 40; // 4rem con base 62.5%
      var CHROME = 90; // buscador + paddings del panel, aprox
      var rect = btn.getBoundingClientRect();
      var below = window.innerHeight - rect.bottom - 24;
      var above = rect.top - 24;
      var fitBelow = Math.floor((below - CHROME) / ITEM);
      var fitAbove = Math.floor((above - CHROME) / ITEM);
      var up = fitBelow < 3 && fitAbove > fitBelow;
      var items = Math.max(3, Math.min(6, up ? fitAbove : fitBelow));
      list.style.maxHeight = items * 4 + 'rem';
      panel.style.top = up ? 'auto' : '';
      panel.style.bottom = up ? 'calc(100% + 0.6rem)' : '';
      var selLi = list.querySelector('.is-selected');
      if (selLi) selLi.scrollIntoView({ block: 'nearest' });
      setTimeout(function () { search.focus(); }, 0);
    }
    function close() {
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }
    function choose(idx) {
      sel.selectedIndex = idx;
      try { sel.dispatchEvent(new Event('change')); } catch (e) {}
      btn.querySelector('.pb-cc-btn__label').textContent = labelText();
    btn.setAttribute('aria-label', ccBase + ' ' + labelText());
      close();
      document.getElementById('ContactForm-phone').focus();
    }

    btn.addEventListener('click', function () { panel.hidden ? open() : close(); });
    search.addEventListener('input', function () { render(search.value); });
    list.addEventListener('click', function (e) {
      var li = e.target && e.target.closest ? e.target.closest('li.pb-cc-item') : null;
      if (li) choose(parseInt(li.dataset.idx, 10));
    });
    search.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); btn.focus(); }
      if (e.key === 'Enter') {
        e.preventDefault();
        var first = list.querySelector('li.pb-cc-item');
        if (first) choose(parseInt(first.dataset.idx, 10));
      }
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !wrap.contains(e.target)) close();
    });

    // Ocultar el select nativo (y su caret del theme) y montar el combobox.
    sel.style.display = 'none';
    var caret = wrap.querySelector(':scope > .svg-wrapper');
    if (caret) caret.style.display = 'none';
    wrap.appendChild(btn);
    wrap.appendChild(panel);
  }

  // Muestra Modelo si "Comprar", Ciudad si "Alquilar". Además hace OBLIGATORIO el campo
  // visible (modelo en compra, ciudad en alquiler) y limpia el required del campo oculto,
  // porque un campo required oculto impide el envío nativo y no es enfocable.
  function setupToggle() {
    var modeloWrap = document.getElementById('pb-modelo-wrap');
    var ciudadWrap = document.getElementById('pb-ciudad-wrap');
    var modelo = document.getElementById('ContactForm-modelo');
    var ciudad = document.getElementById('ContactForm-ciudad');
    var radios = document.querySelectorAll('input[name="contact[Tipo]"]');
    if (!radios.length || !modeloWrap || !ciudadWrap) return;
    function apply() {
      var alquilar = getTipo() === 'Alquilar';
      modeloWrap.style.display = alquilar ? 'none' : '';
      ciudadWrap.style.display = alquilar ? '' : 'none';
      if (modelo) modelo.required = !alquilar; // en compra hay que elegir un modelo para enviar
      if (ciudad) ciudad.required = alquilar;  // en alquiler la ciudad es obligatoria
    }
    for (var i = 0; i < radios.length; i++) radios[i].addEventListener('change', apply);
    apply();
  }

  // Manda el evento por gtag y por dataLayer, lo que haya, y nunca rompe el envío del
  // formulario si no hay ninguno de los dos (mismo criterio que pb-cta-lead.js).
  function trackLead(nombre, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', nombre, params || {});
    } catch (e) {
      /* seguimos: el lead importa más que la métrica */
    }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: nombre }, params || {}));
    } catch (e) {
      /* idem */
    }
  }

  function findForm() {
    var email = document.getElementById('ContactForm-email');
    if (email && email.form) return email.form;
    return document.getElementById('ContactForm');
  }

  function sendToPipedrive() {
    if (!WORKER_URL || WORKER_URL.indexOf('REEMPLAZAR') !== -1) return; // aún sin desplegar
    var attr = getAttribution();
    var payload = {
      nombre: val('ContactForm-name'),
      email: val('ContactForm-email'),
      telefono: composedPhone(), // E.164 compacto (+34623000000) si hay selector; crudo si no
      pb_x1: val('pb-x1'), // honeypot (nombre opaco: ver el comentario en contact-form.liquid)
      origen: window.location.href,
      tipo: getTipo(),
      modelo: val('ContactForm-modelo'),
      ciudad: val('ContactForm-ciudad'),
      // Alta en el boletin. Hasta el 01/09/2026 dependia de una segunda casilla; ese dia se
      // quito y se decidio que entre TODO el que envia el formulario, con el aviso bajo el
      // boton y la baja desde el propio correo. Quien decide de verdad es el Worker, que ya
      // da el alta pase lo que pase: esto viaja para que el backup de Make y el registro
      // digan lo mismo que ha ocurrido.
      newsletter: true,
      // atribución de marketing (oculta, first-touch)
      attrSource: attr.attrSource || '',
      attrCampaign: attr.attrCampaign || '',
      gclid: attr.gclid || '',
      fbclid: attr.fbclid || '',
      referrer: attr.referrer || '',
      landing: attr.landing || '',
    };
    // Sin nombre o sin teléfono no merece la pena molestar al Worker (validará igualmente).
    if (payload.nombre.length < 2 && !payload.telefono) return;

    // Señal de lead limpia para GA4 y para la conversión de Google Ads.
    //
    // Por qué hace falta: la conversión "Contact" de Ads usa hoy `form_submit`, que es
    // la medición mejorada de GA4 y salta con CUALQUIER formulario. En los 28 días al
    // 03/08/2026 fueron 47 eventos, y de esos 5 venían de /cart, 3 de páginas de
    // colección y varios del buscador: solo 17 eran el formulario de contacto. Ads
    // optimiza la puja hacia esa señal, así que cuenta como lead a quien mete algo en
    // el carrito. `generate_lead` sale solo aquí, donde ya sabemos que el envío es el
    // del formulario de contacto y que trae nombre o teléfono.
    trackLead('generate_lead', {
      pagina: window.location.pathname,
      idioma: (document.documentElement.getAttribute('lang') || '').slice(0, 2),
      tipo: payload.tipo || '',
      modelo: payload.modelo || '',
      origen: payload.attrSource || '',
    });

    // Alta en el boletin. Va como evento propio y no como parametro de `generate_lead`
    // porque es el MISMO evento que disparan el pop-up y el bloque del footer: si cada punto
    // de captacion lo cuenta a su manera, no hay forma de comparar cual capta mas, que es
    // justo para lo que existe `punto_captacion`. Desde el 01/09/2026 salta SIEMPRE, porque
    // el alta ya no depende de una casilla: entra todo el que envia el formulario.
    if (payload.newsletter) {
      trackLead('newsletter_subscribe', {
        punto_captacion: 'contacto',
        pais: '',
        idioma: (document.documentElement.getAttribute('lang') || 'es').slice(0, 2),
      });
    }

    try {
      var blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
      if (navigator.sendBeacon && navigator.sendBeacon(WORKER_URL, blob)) return;
    } catch (e) {
      /* cae al fetch keepalive */
    }
    // Fallback: fetch con keepalive (también sobrevive al unload en navegadores modernos).
    try {
      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload),
        keepalive: true,
        mode: 'cors',
      }).catch(function () {});
    } catch (e) {
      /* no bloquear el envío nativo pase lo que pase */
    }
  }

  // ── Panel de agradecimiento (evita el doble envío) ───────────────────────────
  // El envío nativo de Shopify recarga la página, y hasta que la recarga llega el
  // formulario sigue en pantalla con el botón pulsable. El 04/08/2026 un lead pulsó
  // cuatro veces en cinco segundos sobre una conexión lenta y entró cuatro veces en
  // Pipedrive. En cuanto se pulsa Enviar escondemos el formulario y sacamos el panel:
  // sin botón no hay segundo envío. El marcado y el estado tras la recarga los pinta
  // contact-form.liquid; aquí solo se adelanta el cambio para que no dé tiempo a
  // pulsar otra vez.
  function showPanel(el, visible) {
    if (!el) return;
    el.hidden = !visible;
    el.style.display = visible ? '' : 'none';
  }

  function showThanks() {
    var wrap = document.getElementById('pb-form-wrap');
    var thanks = document.getElementById('pb-thanks');
    if (!thanks) return; // plantilla antigua en caché: se queda como estaba, no rompe nada
    showPanel(wrap, false);
    showPanel(thanks, true);
    var title = document.getElementById('pb-thanks-title');
    if (title && title.focus) {
      try {
        title.focus();
      } catch (e) {}
    }
    if (thanks.scrollIntoView) thanks.scrollIntoView({ block: 'center' });
  }

  // ── Sugerencia de errata en el dominio del correo ────────────────────────────
  // La lista de dominios y el Levenshtein se fueron a `pb-email-typo.js` el 01/09/2026,
  // cuando esto mismo hizo falta en el pop-up y en el bloque del footer. Una sola lista
  // para los tres sitios: duplicarla era pedir que se desincronizara.
  //
  // Si ese asset no ha cargado, aqui no se sugiere nada y el formulario sigue funcionando
  // igual: esto es una ayuda, no un requisito para enviar.
  //
  // ⚠️ Y aqui SOLO SUGIERE, nunca bloquea. Un dominio corporativo legitimo puede quedar a
  // una letra de uno comun, y perder el lead entero seria mucho peor que una errata en el
  // correo. En captacion la regla es distinta —ahi si frena el primer intento—, porque un
  // alta al boletin no es un lead de ventas: no hay nada que perder si alguien tiene que
  // pulsar dos veces.

  function setupEmailTypo() {
    var input = document.getElementById('ContactForm-email');
    var aviso = document.getElementById('pb-email-typo');
    if (!input || !aviso) return; // plantilla vieja en cache: no se pinta y no rompe nada
    if (!window.PBEmailTypo) return; // el asset compartido no cargo: sin aviso, sin ruido
    var tpl = aviso.getAttribute('data-tpl') || '';
    var cta = aviso.getAttribute('data-cta') || '';

    input.addEventListener('blur', function () {
      window.PBEmailTypo.pintar(aviso, input, tpl, cta);
    });
    // Mientras corrige a mano, el aviso estorba: se quita al primer tecleo.
    input.addEventListener('input', function () {
      if (!aviso.hidden) window.PBEmailTypo.ocultar(aviso);
    });
  }

  function init() {
    captureAttribution(); // first-touch en cuanto carga la página
    setupToggle();
    setupEmailTypo();
    setupPhoneValidation(); // prefijo internacional + longitud por país (si hay selector)
    buildCountryPicker(); // combobox con buscador sobre el select de prefijo
    var form = findForm();
    if (!form) return;
    // 'submit' en captura: se dispara antes de la navegación; el envío nativo continúa igual.
    // Solo salta si el formulario ha pasado la validación del navegador, así que aquí ya
    // sabemos que el envío va en serio.
    form.addEventListener(
      'submit',
      function () {
        sendToPipedrive();
        // En un tick aparte: que el navegador termine de serializar y lanzar el POST
        // nativo antes de que toquemos el DOM. (Ocultar no excluye campos del envío
        // —solo `disabled` lo hace—, pero así no dependemos de ese detalle.)
        setTimeout(showThanks, 0);
      },
      { capture: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
